import React, {useMemo, useState} from 'react'
import {Stack, Typography} from '@mui/material'
import Modal from '@/components/Modal'
import {colors} from '@/constants'
import PersonalData from '@/components/Modals/Profile/PersonalData'
import {useTranslation} from 'react-i18next'
import Transactions from '@/components/Modals/Profile/Transactions'
import Dashboard from '@/components/Modals/Profile/Dashboard'
import ReferralSystem from '@/components/Modals/Profile/ReferralSystem'
import Antallagi from '@/components/Modals/Profile/Antallagi'
import Support from '@/components/Modals/Profile/Support'
import LoiGame, {LOI_GAME_TAB_LABEL} from '@/components/Modals/Profile/LoiGame'

const Index = ({
  navigate,
  isReferralCode,
}: {
  navigate: (v: string) => void
  isReferralCode?: string
}) => {
  const {t} = useTranslation()
  const [currentTab, setCurrentTab] = useState(isReferralCode ? 3 : 0)

  const tabs = useMemo(
    () => [
      {key: '1247', element: <Dashboard />},
      {key: '1222', element: <PersonalData navigate={navigate} />},
      {key: '1219', element: <Transactions />},
      ...(isReferralCode
        ? [{key: '1249', element: <ReferralSystem code={isReferralCode} />}]
        : []),
      {key: '1735', element: <Support />},
      {key: LOI_GAME_TAB_LABEL, element: <LoiGame />},
      {key: 'ANTALLAGI', element: <Antallagi />},
    ],
    [navigate, isReferralCode]
  )

  const component = tabs[currentTab]?.element ?? tabs[0].element

  return (
    <Modal
      styles={{
        maxWidth: '100%',
        background: '#0F0A00E6',
        width: '100%',
        display: 'flex',
      }}
      stylesContainer={{
        minHeight: '650px',
        boxShadow: '0px 0px 10px 0px #FFF17233',
        border: `1px solid ${colors.lightBrown}`,
        borderRadius: '20px',
        width: '70%',
        minWidth: '1020px',
        height: '85%',
      }}>
      <Stack
        width="25%"
        direction="row"
        boxSizing="border-box"
        bgcolor={colors.brown}
        borderRight="1px solid #FFFDF033"
        justifyContent="center">
        <Stack
          direction="column"
          gap="40px"
          width="fit-content"
          padding="70px 20px 0 20px"
          style={{wordBreak: 'break-word'}}>
          {tabs.map((tab, index) => (
            <Typography
              textAlign="center"
              key={tab.key}
              className="pointer"
              onClick={() => setCurrentTab(index)}
              fontSize="24px"
              fontWeight="600"
              color={currentTab === index ? colors.orange : colors.white}>
              {t(tab.key)}
            </Typography>
          ))}
        </Stack>
      </Stack>
      <Stack
        width="80%"
        justifyContent="center"
        padding="60px 0"
        alignItems="center"
        height="100%"
        boxSizing="border-box">
        {component}
      </Stack>
    </Modal>
  )
}

export default Index
